import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 편지 조회
function getLetterFromMomthera({pid}){
    return AxiosInterceptor({
        url: '/letter',
        method: 'get',
        params: {pid}
    })
}

export default getLetterFromMomthera;